import React, { useState } from "react";
import { FaRegCopyright } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import ContactEmail from "../../components/contact";

const Footer = ({ onCookiePreferencesClick }) => {
  const { t } = useTranslation();
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  return (
    <footer className="w-full bg-[#1b1b1b] text-gray-400 py-6 px-4 sm:px-6 mt-auto">
      <div className="flex flex-col md:flex-row items-center gap-3 justify-center text-sm">
        {/* Copyright Section */}
        {/* <div className="flex items-center text-gray-400">
          <FaRegCopyright className="mr-1" />
          <span>2025 {t("dashboard.buttons.Allrightsreserved")}</span>
        </div> */}

        {/* Links Section */}
        <div className="flex xs:flex-row items-center gap-2 sm:gap-4 text-gray-200">
          {/* <a href="#" className="text-gray-400 hover:text-white transition-colors duration-300">
            {t("createAsset.buttons.Quantial")}
          </a> */}
          {/* <span className="hidden xs:inline">•</span>
          <a href="#" className="text-gray-400 hover:text-white transition-colors duration-300">
            {t("createAsset.buttons.DataProtection")}
          </a> */}
          <span className="hidden xs:inline">•</span>
          <button className="text-gray-400 hover:text-white transition-colors duration-300">
            <Link to="/terms-and-conditions">
              {t("createAsset.buttons.TermsAndCondition")}
            </Link>
          </button>
          <span className="hidden xs:inline">•</span>
          <button
            onClick={onCookiePreferencesClick}
            className="text-gray-400 hover:text-white transition-colors duration-300 bg-transparent border-none cursor-pointer"
          >
            {t("modal.title")}
          </button>
          <span className="hidden xs:inline">•</span>
          <button className="text-gray-400 hover:text-white transition-colors duration-300 bg-transparent border-none cursor-pointer">
            <Link to="/contact">{t("modal.contactUs")}</Link>
          </button>
          <span className="hidden xs:inline">•</span>
          <button className="text-gray-400 hover:text-white transition-colors duration-300 bg-transparent border-none cursor-pointer">
            <Link to="/legal-notice">{t("modal.legalnotice")}</Link>
          </button>
          {/* <span className="hidden xs:inline">•</span>
          <button className="text-gray-400 hover:text-white transition-colors duration-300 bg-transparent border-none cursor-pointer">
            <Link to="/data-processing">{t("modal.dataprocessing")}</Link>
          </button> */}
          <span className="hidden xs:inline">•</span>
          <button className="text-gray-400 hover:text-white transition-colors duration-300 bg-transparent border-none cursor-pointer">
            <Link to="/privacy-policy">
              {t("impressum.labels.privacyPolicy")}
            </Link>
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
